export const themeEditorUiConfigCountup = [
  {
    sectionName: "Content Blocks - Countup",
    sectionKey: "contentBlocks.countup",
    description: "Styling for countup content block type",
    groups: [
      {
        groupName: "Common",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countup.container.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countup default text color",
            options: {
              allowInherit: true,
              modalTitle: "Countup Default Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.countup.container.background",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countup default background color",
            options: {
              allowInherit: true,
              modalTitle: "Countup Default Background Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countup.container.fontSize",
            component: "FontSizeSelector",
            default: "1.75rem",
            allowCustom: true,
            description: "Countup default font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countup.container.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countup default font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countup.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countup default font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Header",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countup.header.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countup header text color",
            options: {
              allowInherit: true,
              modalTitle: "Countup Header Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countup.header.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countup header font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countup.header.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countup header font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countup.header.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countup header font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Value",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countup.value.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countup value text color",
            options: {
              allowInherit: true,
              modalTitle: "Countup value Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countup.value.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countup value font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countup.value.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countup value font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countup.value.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countup value font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Label",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countup.label.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Countup label text color",
            options: {
              allowInherit: true,
              modalTitle: "Countup Label Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countup.label.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countup label font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countup.label.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Countup label font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countup.label.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countup label font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
      {
        groupName: "Footer",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.countup.footer.color",
            component: "ColorSelector",
            default: "#dc2626",
            description: "Countup footer text color",
            options: {
              allowInherit: true,
              modalTitle: "Countup Footer Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "contentBlocks.countup.footer.fontSize",
            component: "FontSizeSelector",
            default: "3rem",
            allowCustom: true,
            description: "Countup footer font size",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.countup.footer.fontWeight",
            component: "FontWeightSelector",
            default: "700",
            description: "Countup footer font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.countup.footer.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Countup footer font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
    ],
  },
];
